import * as types from './mutation-types'
import client from '@/base/api/client'

export default {
  login: ({ commit, state }, authInfo) => {
    return client.auth({ data: { auth: { api: 'AuthService.postingLogin', input: authInfo } } })
      .then((data) => {
        if (data.auth.output) {
          localStorage.setItem('ps_user', data.auth.output.username)
          localStorage.setItem('ps_user_id', data.auth.output.id)
          localStorage.setItem('token', '1')
          localStorage.setItem('user_role', data.auth.output.role)
          commit(types.AUTH_LOGIN, localStorage.getItem('token'))
        }
      })
      .catch(err => { throw err })
  },
  logout: ({ commit, state }) => {
    localStorage.removeItem('ps_user')
    localStorage.removeItem('ps_user_id')
    localStorage.removeItem('token')
    localStorage.removeItem('user_role')
    commit(types.AUTH_LOGOUT, null)
    return client.auth({ data: { auth: {api: 'AuthService.postingLogout'} } })
  },
  initUser: ({ commit, state }) => {
    return client.auth({ data: { auth: { api: 'AuthService.postingGetLoginUser', input: {} } } })
      .then((data) => {
        if (data.auth.output) {
          localStorage.setItem('ps_user', data.auth.output.username)
          localStorage.setItem('ps_user_id', data.auth.output.id)
          localStorage.setItem('token', '1')
          localStorage.setItem('user_role', data.auth.output.role)
          commit(types.AUTH_LOGIN, localStorage.getItem('token'))
        } else {
          localStorage.removeItem('ps_user')
          localStorage.removeItem('ps_user_id')
          localStorage.removeItem('token')
          localStorage.removeItem('user_role')
          commit(types.AUTH_LOGIN, null)
        }
        return data.auth.output
      })
  }
}
